/** Роли в семье и права — по таблице из ТЗ. */
export const ROLES = ['owner', 'parent', 'relative', 'nanny'] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABEL: Record<Role, string> = {
  owner: 'владелец',
  parent: 'родитель',
  relative: 'родственник',
  nanny: 'няня',
};

export type Permission =
  | 'events.read'
  | 'events.write'
  | 'events.deleteOthers'
  | 'child.edit'
  | 'family.manage';

const MATRIX: Record<Role, readonly Permission[]> = {
  owner: ['events.read', 'events.write', 'events.deleteOthers', 'child.edit', 'family.manage'],
  parent: ['events.read', 'events.write', 'events.deleteOthers', 'child.edit'],
  relative: ['events.read'],
  nanny: ['events.read', 'events.write'],
};

export function can(role: Role, perm: Permission): boolean {
  return MATRIX[role].includes(perm);
}

/** Роли, которые владелец может выдать по приглашению (владелец один). */
export const INVITABLE_ROLES: readonly Role[] = ['parent', 'relative', 'nanny'];
